import * as React from 'react';
import {
    PropertyCreate,
    createProperty,
    PropertyConfiguration,
    TimeZone
} from '../../../../api/Property';
import PropertyInfoForm from './PropertyInfoForm';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import { defaultDayConfiguration } from './EditPropertyPane';
import * as moment from 'moment';
import { momentDateFormat } from '../../../../utilities/formatting';

interface State extends PropertyCreate {
    isLoading: boolean;
    wasPropertyInfoFormValidated: boolean;
    successMessage?: string;
}

interface Props {
    availableTimeZones?: TimeZone[];
    companyCreatedFrom: number;
    onPropertyCreate: (newPropertyId: number) => void;
    onErrorMessageUpdate: (errorMessage?: string) => void;
    errorMessage?: string;
}

const defaultPropertyConfiguration: PropertyConfiguration = {
    monday: defaultDayConfiguration,
    tuesday: defaultDayConfiguration,
    wednesday: defaultDayConfiguration,
    thursday: defaultDayConfiguration,
    friday: defaultDayConfiguration,
    saturday: defaultDayConfiguration,
    sunday: defaultDayConfiguration
};

class CreatePropertyPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            id: 0,
            name: '',
            contactEmail: '',
            contactPhone: '',
            streetAddress: '',
            city: '',
            state: '',
            zip: '',
            companyId: props.companyCreatedFrom,
            slug: '',
            propertyImage: '',
            propertyConfiguration: defaultPropertyConfiguration,
            petPolicy: '',
            requestPetInformation: false,
            requestDesiredLeaseLength: true,
            requestCreditCard: true,
            wasPropertyInfoFormValidated: false,
            isLoading: false,
            timeZoneId: '',
            leasingUrl: '',
            goLiveDate: moment().format(momentDateFormat),
            startDay: 0,
            prospectMessagesSuppressions: 0,
            sendNoShowMessagesToProperty: false,
            hideFromSearches: false,
            beaconUuid: '',
            leadForwardingId: 0,
            unitManagementId: 0,
            leadForwardingTypes: [],
            unitManagementTypes: [],
            isMobileRedirect: false,
            warmLeadsStatus: true,
            applicationWidgetStatus: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
        return (
            <div>
                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={true} />
                <FormValidationDisplay
                    successMessage={this.state.successMessage}
                    errorMessage={this.props.errorMessage}
                />
                <PropertyInfoForm
                    {...this.state}
                    availableTimeZones={this.props.availableTimeZones}
                    onChange={this.handleInputChange}
                    onSubmit={this.handleSubmit}
                    wasFormValidated={this.state.wasPropertyInfoFormValidated}
                    onFormValidated={() => this.setState({ wasPropertyInfoFormValidated: true })}
                    newProperty={true}
                />
            </div>
        );
    }

    private handleInputChange(inputName: string, newValue: string | boolean | number) {
        this.setState({
            ...this.state,
            [inputName]: newValue,
            successMessage: undefined
        });
    }

    private async handleSubmit() {
        this.setState({ isLoading: true });

        let submitResult = await createProperty(this.state);
        if (submitResult.success && submitResult.data) {
            this.setState({ successMessage: 'Property Created' });
            this.setState({ isLoading: false });
            this.props.onPropertyCreate(submitResult.data.id);
        } else {
            this.props.onErrorMessageUpdate(submitResult.error);
            this.setState({ isLoading: false });
        }
    }
}

export default CreatePropertyPane;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/CreatePropertyPane.tsx